import gsap from 'gsap'

import {
  buttonRevealAnimation,
  fadeInAnimation,
  SharedAnimation,
  titleRevealAnimation
} from './shared'
import { Animation } from '@/types'

export const doubleParagraph = ({
  node,
  reverse,
  mobile,
  context
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const pretitle = selector('[data-motion-pretitle]')
  const title = selector('[data-motion-title]')
  const paragraph = selector('[data-motion-paragraph]')
  const cta = selector('[data-motion-cta]')

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%',
    markers: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }

  const timeline = gsap.timeline({
    scrollTrigger
  })

  let pretitleAnimation: SharedAnimation
  if (pretitle.length > 0) {
    pretitleAnimation = fadeInAnimation(pretitle)
    timeline.add(pretitleAnimation.timeline, '<')
  }

  let titleAnimation: SharedAnimation
  if (title.length > 0) {
    titleAnimation = titleRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, '<')
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph.length > 0) {
    paragraphAnimation = fadeInAnimation(paragraph)
    timeline.add(paragraphAnimation.timeline, '<')
  }

  let ctaAnimation: SharedAnimation
  if (cta.length > 0) {
    ctaAnimation = buttonRevealAnimation(cta)
    timeline.add(ctaAnimation.timeline, '<+0.3')
  }

  return () => {
    if (pretitleAnimation) {
      pretitleAnimation.revert()
    }
    if (titleAnimation) {
      titleAnimation.revert()
    }
    if (paragraphAnimation) {
      paragraphAnimation.revert()
    }
    if (ctaAnimation) {
      ctaAnimation.revert()
    }
  }
}
